<script setup lang="ts">
import SVG from "@/stories/displays/SVG/SVG.vue";
import type { SVGName } from "@/SVGs";

interface Props {
  icon: SVGName;
  to: string;
  title: string;
  active?: boolean;
}

defineProps<Props>();

defineEmits(["click"]);
</script>

<template>
  <RouterLink
    :to="to"
    class="h600 flex items-center gap-2 px-2"
    @click="$emit('click')"
  >
    <SVG :icon="icon" width="32" height="32"></SVG>
    {{ title }}
  </RouterLink>
</template>
